module.exports = "/images/user-icon-selected.svg?b4a6a25d69c023687e8d1360a02b255a";